import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import className from 'classnames';
import { Field } from 'react-final-form';
import { Checkbox, Icon, Label } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';

function BarcodePatternValues({
  item,
  snapshot,
  draggableProvided,
  fieldLabel,
  fieldIndex,
}) {
  const usePortal = snapshot.isDragging;

  const ItemElement = (
    <div
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      {...draggableProvided.dragHandleProps}
      className={className(styles.ItemWrapper, {
        [`${styles['ItemWrapper--dragging']}`]: snapshot.isDragging,
      })}
      role="button"
    >
      <Icon icon="drag-drop" />

      <strong>
        <FormattedMessage
          id={`ui-plugin-inventory-templates.barcode.pattern.settings.values.${fieldLabel}`}
          defaultMessage={fieldLabel}
        />
      </strong>
    </div>
  );

  if (!usePortal) {
    return ItemElement;
  }

  const container = document.getElementById('ModuleContainer');
  return ReactDOM.createPortal(ItemElement, container);

  //   return ItemElement;
}

BarcodePatternValues.propTypes = {
  fields: PropTypes.object,
  snapshot: PropTypes.object,
  draggableProvided: PropTypes.object,
  item: PropTypes.string,
  fieldLabel: PropTypes.string,
  fieldIndex: PropTypes.number,
};

export default BarcodePatternValues;
